import {atom} from "recoil";
import {persistAtomEffect} from "../effects/persistAtom";

export const portalAuthState = atom({
  key: 'portalAuthState',
  default: null,
  effects: [
    persistAtomEffect
  ]
});
